/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import { object } from 'prop-types';
import DeliveryHours from '../TrackOrder/DeliveryHours';

const styles = (theme) => ({
    container: {
        maxWidth: theme.palette.myAccount.container.maxWidth.upLarge,
        margin: '0 auto',
        alignItems: 'center',
    },
    pageHeadingInner: {
        display: 'inline-block',
        width: '450px',
    },
    heading: {
        display: 'flex',
        fontSize: '15px',
        fontWeight: '700',
        textTransform: 'uppercase',
        marginBottom: '24px',
        paddingLeft: '24px',
        width: 'calc(100% - 450px)',
    },
});

const DesktopOrderHeader = ({ classes }) => (
    <Grid className={classes.container} container>
        <Grid className={classes.heading}>
            <h2 className="no-margin">Order History</h2>
        </Grid>
        <Grid className={classes.pageHeadingInner}>
            <DeliveryHours shadowEffect />
        </Grid>
    </Grid>
);
DesktopOrderHeader.propTypes = {
    classes: object.isRequired,
};

export default withStyles(styles)(DesktopOrderHeader);
